import React from "react";
import PRODUCTS from "../../Component/productData";

const RentalProducts = ({ handleAddToCart }) => {
  const rentalProducts = PRODUCTS.filter(
    (product) => product.sectionName === "Rental-Products"
  );

  return (
    <div className="section-rental-container">
    <h1 className="text-center mb-5" style={{ fontSize: 50 }}>Rental Products</h1>
    <div className="products2-container">
        
      {rentalProducts.length === 0 ? (
        <p>No rental products available.</p>
      ) : (
        rentalProducts.map((product) => (
          <div key={product.id} className="product-card2">
            <img src={product.image} alt={product.name} />
            <h3>{product.name}</h3>
            {/* <p>
              {typeof product.price === "number"
                ? `₹${product.price.toLocaleString()}`
                : "Price: Contact for details"}
            </p> */}
            {/* <button onClick={() => handleAddToCart(product)}>
              Add to Cart
            </button> */}
            
          </div>
        ))
      )}
    </div>
    <h4 className="rental-details" style={{color:"red"}}>"Interested in renting this product? Just give us a call to book now!"</h4>
    </div>
  );
};

export default RentalProducts;









